import { hasPlusAddressAlias } from '@/convex/auth/signup_domain_policy';

/**
 * Trims and lowercases a sign-up email. It never rewrites the local part: the
 * address the person typed is the one we create and verify (#4374).
 */
export function normalizeSignUpEmail(email: string | null | undefined): string {
  if (typeof email !== 'string') {
    return '';
  }

  return email.trim().toLowerCase();
}

/** `+` aliases are rejected at sign-up rather than silently stripped. */
export function isPlusAliasSignUpEmail(email: string): boolean {
  return hasPlusAddressAlias(email);
}
